// Use modular SDK for Firebase v9+ (including v11)
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCyuWjyNiRGIGU5Iou5jjAvBoyCSTv2Ms8",
  authDomain: "numente-1014.firebaseapp.com",
  projectId: "numente-1014",
  storageBucket: "numente-1014.firebasestorage.app",
  messagingSenderId: "903524857362",
  appId: "1:903524857362:web:8d49139895c887c6e3cacb",
  measurementId: "G-X9VGJCPFFK",
};
const VAPID_KEY = "BFDlyMJPZnJzQ6ug_pks-9lkfe_7WJ0xG-gMsZnP71ne9s2EEPrmcr1P8bIDkN7791nWDrKVWyNTwn53Mdlb58c";

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
console.debug('[Firebase] App initialized with projectId:', firebaseConfig.projectId);
const messaging = getMessaging(firebaseApp);
console.debug('[Firebase] Messaging initialized');

export { firebaseApp, messaging, VAPID_KEY };